import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import { usePageLocale } from '../../components/i18n/usePageLocale'
import back from "../../assets/images/elements/aboutHeader.jpg"; // Можна замінити на профільне фото або інший фон
import articlePdf from "../../resources/2_the-gods-will.pdf"

export const Article2TheGodsWill = () => {
    const ready = usePageLocale('article2');
    if (!ready) return <div style={{ padding: '60px', textAlign: 'center', color: '#999' }}>•••</div>;
    return (
        <section className='text_container_light'>
            <div className='container_100'>
                {/* Верхній блок з заголовком (як у About) */}
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle2Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    {/* Кнопка повернення */}
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА: Метадані та Анотація */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle2Title")}</h2>

                            <p><i>{t("resourceArticle2Source")}</i><br/></p>
                            <p>{t("resourceArticle2Author")}</p>

                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle2AnnotationHeader")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P1_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P1_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P1_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P1_4") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle2Sec2")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P2_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P2_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P2_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P2_4") }} /></p>

                            <br />


                        </div>

                        {/* ПРАВА КОЛОНКА: Основний зміст */}
                        <div>
                            <h3 className='menuColor'>{t("resourceArticle2Sec3")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P3_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P3_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P3_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P3_4") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle2Sec4")}</h3>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P4_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P4_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P4_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P4_4") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle2Sec5")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle2P5_1") }} /></p>

                            <br/>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle2Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                </div>
                <br />
            </div>
        </section>
    )
}
